const setting = () => {
  $("form").on("keydown", event => {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  });
};

export default setting;
